import * as React from 'react';
import styled from 'styled-components';

// Components
import { SelectField } from '../../../../../../../../../components/SelectField';
import { PlainRenderInputElement } from './PlainRenderInputElement';

// Context
import { CriteriaStoreContext } from '../../../../../../../state/criteria/context';
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { useResourceOptions } from '../../../../../../../api/hooks/useResourceOptions';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const OperatorResourceContainer = styled.div`
    min-width: 8rem;
`;

const OPERATOR_RESOURCE_PLACEHOLDER = 'operator resource';

export const OperatorResource = ({ id, plainrender = true, ...props }) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();
    const resourceOptionsQuery = useResourceOptions({
        sessionToken,
        resourceId: part?.criteriaResourceDTO?.resourceId,
        queryOptions: {
            enabled: !plainrender
        }
    });
    const resourceOptions = React.useMemo(() => {
        return (resourceOptionsQuery?.data ?? []).map(({ paramId, name }) => ({
            value: paramId,
            label: name
        }));
    }, [resourceOptionsQuery?.data]);

    if (plainrender) {
        return (
            <PlainRenderInputElement
                value={part?.criteriaResourceParamDTO?.name}
                placeholderPartial={OPERATOR_RESOURCE_PLACEHOLDER}
                overridable={part?.overridable}
            />
        );
    } else {
        return part?.criteriaResourceDTO?.resourceId ? (
            <OperatorResourceContainer>
                <SelectField
                    withBorder
                    menuPortalDocument
                    className=""
                    value={
                        part?.criteriaResourceParamDTO?.paramId
                            ? resourceOptions.filter(
                                  (option) => option.value === part?.criteriaResourceParamDTO?.paramId
                              )
                            : undefined
                    }
                    onChange={(selectedOption) => {
                        setEdited(true);
                        updatePredicateElement({
                            ...part,
                            dtoState: dtoState.Updated,
                            criteriaResourceParamDTO:
                                typeof part?.criteriaResourceParamDTO !== 'undefined'
                                    ? {
                                          ...part.criteriaResourceParamDTO,
                                          paramId: selectedOption.value,
                                          name: selectedOption.label,
                                          dtoState: dtoState.Updated
                                      }
                                    : {
                                          paramId: selectedOption.value,
                                          name: selectedOption.label,
                                          dtoState: dtoState.New
                                      }
                        });
                    }}
                    options={resourceOptions}
                    placeholder="..."
                    tabIndex="0"
                    size={`xs`}
                    id={`part_select_${id}`}
                    name={`part_select_${id}`}
                />
            </OperatorResourceContainer>
        ) : null;
    }
};

export default OperatorResource;

OperatorResource.propTypes = {
    ...ruleEditorViewPartCommonProps
};
